import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import wrapperStyles from './panel-wrapper.lit.scss';
import { KatPanel } from './panel';

/** A wrapper for a kat-panel. Controls how the panel interacts with its side-by-side content. */
@register('kat-panel-wrapper')
export class KatPanelWrapper extends KatLitElement {
  static get styles() {
    return [baseStyles, wrapperStyles];
  }

  /** The visibility of the slotted kat-panel. Can also be controlled via the `visible` property on the panel. Defaults to false. */
  @property({ attribute: 'panel-visible' })
  panelVisible?: boolean = false;

  /** The behavior of how the slotted kat-panel interacts with the content. Defaults to overlay. */
  @property()
  variant?: 'slide' | 'overlay' = 'overlay';

  /** The size of the panel. Defaults to 'small'. */
  @property()
  size?: 'small' | 'large' = 'small';

  constructor() {
    super();

    const panel = this.querySelector<KatPanel>('kat-panel');
    this.panelVisible = panel.visible;

    this._listeners = [
      [
        'close',
        e => {
          this.panelVisible = e.detail.visible;
        },
      ],
      [
        'open',
        e => {
          this.panelVisible = e.detail.visible;
        },
      ],
    ];
  }

  //TODO: Should auto-slot panel
  render() {
    return html`
      <div class="content">
        <slot></slot>
      </div>
      <slot name="panel"></slot>
    `;
  }
}
